import { useEffect, useRef, type ReactNode } from 'react';
import { t } from '../i18n';

// Modales Fenster auf Basis von <dialog>. Esc und Klick außerhalb schließen.
export function Dialog({
  open,
  onClose,
  title,
  children,
  className,
}: {
  open: boolean;
  onClose(): void;
  title: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (open && !d.open) d.showModal();
    if (!open && d.open) d.close();
  }, [open]);
  return (
    <dialog
      ref={ref}
      className={`dlg ${className ?? ''}`}
      onClose={onClose}
      onCancel={(e) => {
        e.preventDefault();
        onClose();
      }}
      onClick={(e) => {
        if (e.target === ref.current) onClose();
      }}
      aria-labelledby="dlg-title"
    >
      {open && (
        <div className="dlg-in">
          <h2 id="dlg-title">{title}</h2>
          {children}
        </div>
      )}
    </dialog>
  );
}

// Rückfrage mit zwei Knöpfen, z. B. „Ja, löschen“ / „Abbrechen“.
export function ConfirmDialog({
  open,
  title,
  text,
  confirmLabel,
  cancelLabel = t('Abbrechen'),
  danger,
  busy,
  onConfirm,
  onCancel,
}: {
  open: boolean;
  title: ReactNode;
  text?: ReactNode;
  confirmLabel: string;
  cancelLabel?: string;
  danger?: boolean;
  busy?: boolean;
  onConfirm(): void;
  onCancel(): void;
}) {
  return (
    <Dialog open={open} onClose={onCancel} title={title}>
      {text && <p className="muted">{text}</p>}
      <div className="dlg-actions">
        <button type="button" className="btn" onClick={onCancel}>
          {cancelLabel}
        </button>
        <button type="button" className={`btn ${danger ? 'dark' : 'primary'}`} onClick={onConfirm} disabled={busy} autoFocus>
          {confirmLabel}
        </button>
      </div>
    </Dialog>
  );
}
